import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import styles from './WeekdayPicker.module.css';
import { WEEKDAYS } from '../../utils';
class WeekdayPicker extends React.Component {
    constructor() {
        super(...arguments);
        this.renderWeekday = (id, weekday, isSelected, disabled) => {
            const handleOnChange = (e) => {
                e.currentTarget.blur();
                this.props.onChange(weekday);
            };
            return (_jsxs("label", Object.assign({ className: `${styles.label} ${disabled ? styles.labelDisabled : ''}`, htmlFor: `${WEEKDAYS[weekday]}-${id}` }, { children: [_jsx("input", { className: styles.weekdayInput, onChange: handleOnChange, checked: isSelected, type: "checkbox", value: WEEKDAYS[weekday], disabled: disabled, id: `${WEEKDAYS[weekday]}-${id}` }, void 0), _jsx("span", Object.assign({ className: `${styles.weekday} ${isSelected ? styles.active : ''} ${disabled ? styles.disabled : ''}` }, { children: WEEKDAYS[weekday] }), void 0)] }), weekday));
        };
        this.renderWeekdays = () => {
            const { id, selectedWeekdays, disabled = false, error = false, customErrorText = 'Weekdays cannot be empty', } = this.props;
            let weekdays = [];
            for (let i = 0; i < 7; i++) {
                const isSelected = selectedWeekdays.includes(i);
                weekdays = [...weekdays, this.renderWeekday(id, i, isSelected, disabled)];
            }
            return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: `${styles.container} ${error ? styles.error : ''}` }, { children: weekdays }), void 0), error ? (_jsx("div", Object.assign({ className: styles.errorText }, { children: customErrorText }), void 0)) : null] }, void 0));
        };
    }
    render() {
        return this.renderWeekdays();
    }
}
export default WeekdayPicker;
